<template>
  <v-container class="py-0" fluid>
    <v-row no-gutters>
      <v-col md="12" cols="12">
        <v-row>
          <v-col cols="12">
            <component
              v-bind:is="dashboardData.chart1.type"
              :title="dashboardData.chart1.title"
              :options="dashboardData.chart1.options"
              :height="360"
              @filter="filter"
            ></component>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <component
              v-bind:is="dashboardData.chart2.type"
              :title="dashboardData.chart2.title"
              :options="dashboardData.chart2.options"
              :height="300"
              @filter="filter"
            ></component>
          </v-col>
          <v-col md="6" cols="12">
            <component
              v-bind:is="dashboardData.chart3.type"
              :title="dashboardData.chart3.title"
              :options="dashboardData.chart3.options"
              :height="300"
              @filter="filter"
            ></component>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DashboardMixin from "@/components/mixins/dashboard.js";
export default {
  mixins: [DashboardMixin],
};
</script>
